import {useEffect, useLayoutEffect, useRef, useState} from '@wordpress/element'
import React from 'react'
import {BaseProps} from "../types";


export default function HeaderNavBar(props: BaseProps) {
  const dom = useRef<HTMLDivElement>(null)
  const [selectedDom, setSelectedDom] = useState<Element>(null)

  const nestedMenuContainer = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const x = document.getElementById('nested-navbar-placeholder') as HTMLDivElement
    nestedMenuContainer.current = x

    const menuItems = dom.current.querySelectorAll(':scope > .menu-nav-item')
    menuItems.forEach(item => {
      item.addEventListener('click', () => {
        if (item.classList.contains('active')) {
          item.classList.remove('active')
          setSelectedDom(undefined)
          nestedMenuContainer.current.classList.add('hidden')
        } else {
          item.classList.add('active')
          const hasChildren = !!item.querySelector('ul')
          setSelectedDom(item)
          if (hasChildren) {
            nestedMenuContainer.current.classList.remove('hidden')
          }
        }
      })
    })
  }, [])


  return (
    <div className={props.className} ref={dom} dangerouslySetInnerHTML={{__html: props.children}}>
    </div>
  )

}